import React, { Component } from 'react';

class SidebarEn extends Component{
    render(){

        let data = [
            {sidebarListLink: "Crusher", sidebarListIcon: 'flaticon-015-cart', sidebarListText: 'Crusher'},
            {sidebarListLink: "Vibrating-Screen", sidebarListIcon: 'flaticon-010-tank-1', sidebarListText: 'Vibrating Screen'},
            {sidebarListLink: "Mill", sidebarListIcon: 'flaticon-002-welding', sidebarListText: 'Mill'},
            {sidebarListLink: "Concentration", sidebarListIcon: 'flaticon-004-walkie-talkie', sidebarListText: 'Concentration'},
            {sidebarListLink: "Material-handling", sidebarListIcon: 'flaticon-042-monitor', sidebarListText: 'Material handling'},
            {sidebarListLink: "Thickening-and-Filtering", sidebarListIcon: 'flaticon-050-boxes', sidebarListText: 'Thickening and Filtering'},
            {sidebarListLink: "Concentrate-drying", sidebarListIcon: 'flaticon-050-boxes', sidebarListText: 'Concentrate drying'},
            {sidebarListLink: "Laboratory-equipment", sidebarListIcon: 'flaticon-050-boxes', sidebarListText: 'Laboratory equipment'},
            {sidebarListLink: "Spare-parts-and-consumables", sidebarListIcon: 'flaticon-050-boxes', sidebarListText: 'Spare parts and consumables'},
            {sidebarListLink: "Complete-Plants", sidebarListIcon: 'flaticon-018-power-tower', sidebarListText: 'Complete Plants'},
        ];

        let Datalist = data.map((val, i)=>{
            return(
                <li key={i}><a href={val.sidebarListLink}><i className={val.sidebarListIcon} />{val.sidebarListText}</a></li>
            )
        })

        return(
            <div>
                <div className="sidebar-wrapper">
                    <div className="sidebar">
                        <h3 className="sidebar-title">Equipment</h3>
                        <ul className="sidebar-list">
                            {Datalist}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default SidebarEn;